import React, { ReactNode } from "react";
import { Each } from "../Each";
import { getValue } from "../../utils/object.utils";
import { Divider } from "../Divider";
import { Colors } from "../../Constants/colors";
import { CardBadge, CardBadgeProps } from "../Badge/CardBadge";
import { Pagination } from "../pagination";

interface PaginationInterface {
  totalPage: number;
  onPageChange: (page: number) => unknown;
  isSelected?: boolean;
  onListSelected?: () => unknown;
}
interface Props {
  childrens: {
    child: ReactNode;
    badge?: CardBadgeProps;
  }[];
  pagination?: PaginationInterface;
  listStyle?: React.CSSProperties;
}

export const ListView = ({ childrens, pagination, listStyle = {} }: Props) => {
  return (
    <>
      <div
        className="pl-2 pr-2"
        style={{
          maxHeight: "580px",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <div
          className="flex flex-col gap-1"
          style={{
            border: `1px solid ${Colors.LightAshRose}`,
            borderRadius: "4px",
          }}
        >
          <Each
            of={childrens}
            render={(item, index, childrens) => {
              const child = getValue(item, "child", null);
              const isLastItem = childrens.length - 1 === index;
              const isFirstItem = index === 0;
              const badge = getValue(item, "badge", null) as CardBadgeProps;
              const isSelected = getValue(item, "isSelected", false);
              const onListSelected = getValue(item, "onListSelected", null);

              return (
                <div
                  style={{
                    position: "relative",
                  }}
                  onClick={() => {
                    if (onListSelected) {
                      onListSelected();
                    }
                  }}
                >
                  <div
                    className={`gap-4 pt-4 ${
                      isLastItem ? "pb-8" : "pb-4" // because divider take up some spaces.
                    } pr-2 pl-2`}
                    style={{
                      backgroundColor: isSelected
                        ? Colors.DarkOffWhite
                        : undefined,
                      cursor: onListSelected ? "pointer" : "default",
                      ...listStyle,
                    }}
                  >
                    {child}
                  </div>
                  {badge ? (
                    <div
                      style={{
                        position: "absolute",
                        top: isFirstItem ? 10 : -10, // because divider take up some spaces.
                        right: -10,
                      }}
                    >
                      <CardBadge
                        badgeText={badge.badgeText}
                        badgeType={badge.badgeType}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  {!isLastItem ? <Divider /> : <></>}
                </div>
              );
            }}
          />
        </div>
      </div>
      {!!pagination ? (
        <Pagination
          totalPage={pagination.totalPage}
          onPageChange={pagination.onPageChange}
        />
      ) : (
        <></>
      )}
    </>
  );
};
